import { SPECIAL_LOGIN_ORDER_ID_QUERY_KEY } from '@constants'
import type { SpecialLoginParams } from '../components/cosign/login/types'

export function getSpecialLoginParams(): SpecialLoginParams {
  const orderId = new URLSearchParams(window.location.search).get(SPECIAL_LOGIN_ORDER_ID_QUERY_KEY) ?? ''
  return { isSpecialLogin: !!orderId, orderId }
}
